<template>
  <el-dialog class="custon-dialog-title" title="Contato com Cliente" @open="reset()" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="45%" v-loading="isLoading">
    <!-- NOVO CONTATO REALIZADO -->
    <el-form :model="contatoRealizado" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" v-if="isNovo">
      <el-row :gutter="10">
        <el-col :span="12" :xs="24">
          <el-form-item class="form-item" label="Data/Hora de Abertura" prop="data">
            <el-date-picker
              v-model="contatoRealizado.data"
              placeholder="01/01/2019 16:00"
              v-mask="'##/##/#### ##:##'"
              :disabled="desabilitarCampos"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="24">
          <el-form-item class="form-item" label="Data/Hora de Retorno" prop="dataProximoContato">
            <el-date-picker
              v-model="contatoRealizado.dataProximoContato"
              placeholder="01/01/2019 16:00"
              v-mask="'##/##/#### ##:##'"
              :disabled="desabilitarCampos"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="Atendente" style="width: 100%">
            <el-select
              v-model="contatoRealizado.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              :disabled="desabilitarCampos"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item class="form-item" label="Assunto" prop="assunto" style="width: 100%">
            <el-input v-model="contatoRealizado.assunto" :disabled="desabilitarCampos"></el-input>
            <small class="form-text-small" :style="validarAssunto ? 'visibility: hidden;' : 'visibility: visible'">* Deve ter pelo menos 5 caracteres.</small>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item class="form-item" prop="descricao" label="Descrição">
            <el-input :disabled="isConcluido" v-model="contatoRealizado.descricao" type="textarea" :rows="8"></el-input> 
            <small class="form-text-small" :style="validarDescricaoNovo ? 'visibility: hidden;' : 'visibility: visible'">* Deve ter pelo menos 5 caracteres.</small>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24" v-if="isConcluido">
          <el-form-item class="form-item" prop="motivoFinalizacao" label="Motivo da Finalização">
            <el-input class="input-desabilitado" v-model="contatoRealizado.motivoFinalizacao" type="textarea" :rows="1" :disabled="desabilitarCampos"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- EM ANDAMENTO/CONCLUIDO-->
    <el-form :model="contatoRealizado" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" v-if="!isNovo">   
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Data/Hora de Abertura</label>
            <span>{{contatoRealizado.data}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Atendente</label>
            <span>{{contatoRealizado.usuario.nome}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Assunto</label>
            <span>{{contatoRealizado.assunto}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details dont-word-wrap">
            <label class="font-label">Descrição</label>
            <span v-html="descricao"></span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="isConcluido"> 
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Motivo da Finalização</label>
            <span>{{contatoRealizado.motivoFinalizacao}}</span>
          </div>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" v-if="isEmAndamento">
        <el-col :span="24">
          <el-form-item class="form-item margin-form-item" label="Data/Hora de Retorno" prop="dataProximoContato">
            <el-date-picker
              v-model="contatoRealizado.dataProximoContato"
              placeholder="01/01/2019 16:00"
              v-mask="'##/##/#### ##:##'"
              :disabled="isConcluido"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" v-if="isEmAndamento">
        <el-col :span="24">
          <el-form-item class="form-item margin-form-item" label="Adicionar à Descrição">
            <el-input :disabled="isConcluido" v-model="descricaoAux" type="textarea" :rows="4"></el-input>
            <small class="form-text-small" :style="validarDescricao ? 'visibility: hidden;' : 'visibility: visible'">* Deve ter pelo menos 5 caracteres.</small> 
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>  
    <span slot="footer">
      <el-button v-if="!isNovo" type="danger" size="small" @click="fechar()" round class="btn-box-shadow">Fechar</el-button>
      <el-button v-if="!isConcluido" type="success" size="small" @click="gravar()" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import funcoes from '../../../util/funcoes.js'
import { validadorDataHora } from '../../../util/validadores.js'

export default {
  props: {
    contato: Object,
    visibility: Boolean
  },
  data() {
    return {
      validacao: {
        assunto: [
          { required: true, message: "Assunto é obrigatório" },
        ],
        descricao: [
          { required: true, message: "Descrição é obrigatório" },
        ],
        data: [
          { validator: validadorDataHora, trigger: 'blur' },
        ],
        dataProximoContato: [
          { validator: validadorDataHora, trigger: 'blur' },
        ]        
      },     
      contatoRealizado: {
        data: "",
        dataProximoContato: "",
        assunto: "",
        descricao: "",
        cliente: {
          id: 0
        },
        modulo: "VENDA_CLIENTE",
        motivoFinalizacao: ""
      },
      descricaoAux: "",
      loadingUsuarios: false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.loading,
    }),
    ...mapState('vendasClientesStore', {
      cliente(state) { return state.clienteSelecionado },
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
    }),
    desabilitarCampos(){
      return this.contatoRealizado.id !== undefined && this.contatoRealizado.id !== 0
    },
    exibirFinalizar(){
      return this.contatoRealizado.status && !this.isConcluido
    },
    exibirMotivoFinalizacao(){
      return this.contatoRealizado.status
    },
    //CADASTRAR CONTATO REALIZADO
    isNovo(){
      return this.contatoRealizado.cliente.id === 0
    },
    //ALTERAR CONTATO REALIZADO
    isEmAndamento(){
      return this.contatoRealizado.status === "EM_ANDAMENTO"
    },
    //CONCLUIDO
    isConcluido(){
      return this.contatoRealizado.status === "CONCLUIDO"
    },
    descricao(){
      return this.contatoRealizado.descricao.replace(/\n/g, '<br>');
    },
    validarAssunto(){
      return this.contatoRealizado.assunto.trim().length >= 5
    },
    validarDescricaoNovo(){
      return this.contatoRealizado.descricao.trim().length >= 5
    },
    validarDescricao(){
      return this.descricaoAux.trim().length >= 5;
    },
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('vendasClientesStore', [
      'gravarContatoRealizado',
      'atualizarContatoRealizado',
      'listarUsuarios'
    ]),

    reset() {
      this.contatoRealizado = {
        data: "",
        dataProximoContato: "",
        assunto: "",
        descricao: "",
        cliente: {
          id: 0
        },
        modulo: "VENDA_CLIENTE",
        usuario: this.usuarioLogado
      };
      this.descricaoAux = "";
      if(this.contato && this.contato.id) {
        this.contatoRealizado = this.contato
        this.contatoRealizado.cliente = {}
        this.filtrarUsuariosSelect(this.contatoRealizado.usuario.nome)
      } else {
        this.filtrarUsuariosSelect(this.usuarioLogado.nome)
      }
      
    },
    validarGravarNovo(){
      return (this.contatoRealizado.assunto.trim().length >= 5) && (this.contatoRealizado.descricao.trim().length >= 5)
    },
    gravar() {
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.contatoRealizado.cliente.id = this.cliente.id;
          this.showLoading();
          if(!this.contatoRealizado.id){
            if(this.validarGravarNovo()){
              this.contatoRealizado.descricao += funcoes.agora2();
              this.gravarContatoRealizado(this.contatoRealizado)
              .then(resultado => {
                this.hideLoading();
                switch(resultado.status) {
                  case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.fechar();
                    break;
                  case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                  case "ERRO":
                    this.$message.error(resultado.mensagem);
                    break;
                }
              }).catch(() => {
                this.hideLoading();
              });
            }else {
              this.exibirAlert("Atenção","Preencha todos os campos obrigatórios");        
            } 
          } else {
            if(this.validarDescricao){
              this.contatoRealizado.descricao = this.descricaoAux + funcoes.agora2();
              this.atualizarContatoRealizado(this.contatoRealizado)
              .then(resultado => {
                this.hideLoading();
                switch(resultado.status) {
                  case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.fechar();
                    break;
                  case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                  case "ERRO":
                    this.$message.error(resultado.mensagem);
                    break;
                }
              }).catch(() => {
                this.hideLoading();
              });
            }else{
              this.exibirAlert("Ops...","Adicione uma descrição!");
              this.hideLoading();
            }
          }
        } else {
          this.exibirAlert("Atenção","Preencha todos os campos obrigatórios");        
        }
      })
    },
    finalizarContatoRealizado() {
      this.$confirm('Deseja realmente finalizar este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.contatoRealizado.status = 'CONCLUIDO';
        this.gravar();
      })
    },
    //SELECT
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
      this.loadingUsuarios = false;  
      })
    },
    fechar() {
      this.descricaoAux = ""
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    }
  }
}
</script>
<style scoped>
.details{
  display: flex;
  flex-direction:  column;
  margin: 10px 0;
  padding: 10px;
  background-color: #f9f9f9;
  border-left: 4px solid #28a745;
  border-radius: 5px;
}
.font-label{
  font-weight: bold;
  font: 15px;
  margin-bottom: 5px;
  color: rgb(66, 66, 66);
}
.custon-dialog-title{
  text-align: center;
}
.dont-word-wrap{
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
}
.form-text-small{
  color: red;
  margin-top: -8px;
  display: block;
}

.margin-form-item{
  margin-top: 10px;
}

</style>